'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './event-reservation-admin.routes';

export class EventReservationAdminComponent {

  constructor(ReservableEventService, ReservationService, $uibModal, $timeout, Auth, $state, Config, dialogs, $stateParams) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ReservationService = ReservationService;
    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$timeout  = $timeout;
    this.isAdmin = Auth.isAdminSync;

    this.eventId = $stateParams.id;

    this.reload = _ => $state.go("reservation-"+this.type+"-admin");

    var generalConfig = Config.getModuleConfig(Config.Modules.General);

    this.types = Config.getModuleConfig(Config.Modules.Reservation).getEventTypes();
    this.config = Config.getModuleConfig(Config.Modules.Reservation).getEventSettings();

    this.timezone = generalConfig.getClientTimezone();

    var that = this;

    var getData = () => {

      this.count = {
        underReview: 0,
        accepted: 0,
        declined: 0,
        availableSpots: 0,
        acceptedSpots: 0,
        underReviewSpots: 0
      };

      ReservableEventService.get({id: this.eventId}, event => {

        this.event = event;
        this.count.availableSpots = this.event.totalSpots;

        if (this.config[event.type] && this.config[event.type].hasOwnProperty("customSchema")) {
          this.customSchema = this.config[event.type].customSchema;
        }

        this.pageTitle = this.event.title + " Reservation Review";

        ReservationService.getByEvent({event: this.eventId}, reservations => {

         this.reservations = reservations;

         reservations.forEach(reservation => {
           switch (reservation.state) {
             case 'toBeApproved':
               this.count.underReviewSpots += reservation.spots;
               this.count.underReview++;
               break;
             case 'accepted':
               this.count.acceptedSpots += reservation.spots;
               this.count.availableSpots -= reservation.spots;
               this.count.accepted++;
               break;
             case 'declined':
               this.count.declined++;
               break;
           }
         })

        })

      })
    };

    this.getData = getData;
    getData();

  }

  openEventReservationEdit(reservation) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reservationAdd',
      resolve: {
        config: function() {
          return {
            isAdmin: that.Auth.isAdminSync(),
            event: that.event,
            data: angular.copy(reservation),
            customSchema: that.customSchema
          }
        }
      }
    });

    modalInstance.result.then(
      function (editedEvent) {
        that.ReservationService.update({id: editedEvent._id}, editedEvent, _ => that.getData());
      },
      function () { /* cancel */ }
    );
  }

  decline(reservation) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reasonForm',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (reason) {
        that.ReservationService.setState({id: reservation._id}, {state: 'declined', reason}, _ => that.getData());
      },
      function () { /* cancel */ }
    );

  }

  accept(reservation) {
    var that = this;

    var reservationText = "<br/><br/><b>" + moment(reservation.start).format('MMMM Do YYYY, h:mm')
      + "</b> till <b>" + moment(reservation.end).format('MMMM Do YYYY, h:mm') + "</b>";

    var dlg = this.dialogs.confirm("Accept Reservation?", "Do you want to accept this reservation?" + reservationText);
    dlg.result.then(() => {
      that.ReservationService.setState({id: reservation._id}, {state: 'accepted'}, _ => that.getData());
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduuApp.eventReservationAdmin', [uiRouter])
  .config(routes)
  .component('eventReservationAdmin', {
    template: require('./event-reservation-admin.html'),
    controller: EventReservationAdminComponent,
    bindings: {
      type: '@'
    },
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/event/admin/event-reservation-admin.component.js